import React, { Component } from 'react';
import { Modal as BModal } from 'react-bootstrap';
import { Button, Select, Input, Icon, SelectSearch, Table } from "../../../../components";
import { Globals } from "../../../../utils";
import axios from "../../../../utils/axios";

class ModalDiscount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            type: '',
            name: '',

            // Por surtido
            surtido_min_quantity: '',
            surtido_percentage: '',
            surtido_selected_product: null,
            surtido_counts_for_calculation: 'yes',
            surtido_price_num: '1',

            // Por volumen
            volumen_apply_by: 'producto',
            volumen_selected_product: null,
            volumen_selected_category: null,
            volumen_min_quantity: '',
            volumen_percentage: '',
            volumen_price_num: '1',

            // Por pronto pago
            pronto_pago_days: '',
            pronto_pago_percentage: '',
            pronto_pago_selected_client: null,

            // Por ruta_vendedor
            ruta_vendedor_apply_by: 'ruta',
            ruta_vendedor_selected_zone: null,
            ruta_vendedor_selected_seller: null,
            ruta_vendedor_selected_product: null,
            ruta_vendedor_price_num: '1',
            ruta_vendedor_percentage: '',

            // Por limite_cantidad
            limite_cantidad_special_price: '',
            limite_cantidad_max_quantity: '',
            limite_cantidad_selected_product: null,
            limite_cantidad_price_num: '1',

            // Por surtido y volumen
            surtido_volumen_apply_by: 'producto',
            surtido_volumen_scope: 'todos',
            surtido_volumen_selected_product: null,
            surtido_volumen_selected_category: null,
            surtido_volumen_excluded_products: [],
            surtido_volumen_min_sku: '',
            surtido_volumen_min_bultos: '',
            surtido_volumen_percentage_one: '',
            surtido_volumen_percentage_both: '',
            surtido_volumen_price_num: '1',

            details: [],
            products: [],
            categories: [],
            clients: [],
            sellers: [],
            zones: [],
            loading: false
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.loadSelects();
            if (this.props.discount) {
                const rawDetails = this.props.discount.discount_details || this.props.discount.discountDetails || [];
                const details = this.props.discount.type === 'surtido'
                    ? rawDetails.map(d => ({ ...d, counts_for_calculation: 1 }))
                    : rawDetails;
                let sv_apply_by = 'producto';
                let sv_scope = 'seleccionados';
                let sv_excluded = [];
                if (this.props.discount.type === 'surtido_volumen' && details.length > 0) {
                    if (details[0].category_id || details[0].is_category) sv_apply_by = 'categoria';
                    sv_scope = 'seleccionados';
                }

                this.setState({
                    step: 2,
                    type: this.props.discount.type,
                    name: this.props.discount.name,
                    details: details,
                    surtido_min_quantity: details.length > 0 ? (details[0].min_quantity || '') : '',
                    surtido_percentage: details.length > 0 ? (details[0].percentage || '') : '',
                    surtido_counts_for_calculation: 'yes',
                    surtido_price_num: details.length > 0 ? (details[0].price_num || '1') : '1',

                    surtido_volumen_apply_by: sv_apply_by,
                    surtido_volumen_scope: sv_scope,
                    surtido_volumen_selected_product: null,
                    surtido_volumen_selected_category: null,
                    surtido_volumen_excluded_products: sv_excluded,
                    surtido_volumen_min_sku: details.length > 0 ? (details[0].min_sku || '') : '',
                    surtido_volumen_min_bultos: details.length > 0 ? (details[0].min_bultos || '') : '',
                    surtido_volumen_percentage_one: details.length > 0 ? (details[0].percentage_one_condition || '') : '',
                    surtido_volumen_percentage_both: details.length > 0 ? (details[0].percentage_both_conditions || '') : '',
                    surtido_volumen_price_num: details.length > 0 ? (details[0].price_num || '1') : '1',
                });
            } else {
                this.setState({
                    step: 1,
                    type: '',
                    name: '',
                    details: [],
                    surtido_min_quantity: '',
                    surtido_percentage: '',
                    surtido_selected_product: null,
                    surtido_counts_for_calculation: 'yes',
                    surtido_price_num: '1',
                    volumen_apply_by: 'producto',
                    volumen_selected_product: null,
                    volumen_selected_category: null,
                    volumen_min_quantity: '',
                    volumen_percentage: '',
                    volumen_price_num: '1',
                    pronto_pago_days: '',
                    pronto_pago_percentage: '',
                    pronto_pago_selected_client: null,
                    ruta_vendedor_apply_by: 'ruta',
                    ruta_vendedor_selected_zone: null,
                    ruta_vendedor_selected_seller: null,
                    ruta_vendedor_selected_product: null,
                    ruta_vendedor_price_num: '1',
                    ruta_vendedor_percentage: '',
                    limite_cantidad_special_price: '',
                    limite_cantidad_max_quantity: '',
                    limite_cantidad_selected_product: null,
                    limite_cantidad_price_num: '1',

                    surtido_volumen_apply_by: 'producto',
                    surtido_volumen_scope: 'todos',
                    surtido_volumen_selected_product: null,
                    surtido_volumen_selected_category: null,
                    surtido_volumen_excluded_products: [],
                    surtido_volumen_min_sku: '',
                    surtido_volumen_min_bultos: '',
                    surtido_volumen_percentage_one: '',
                    surtido_volumen_percentage_both: '',
                    surtido_volumen_price_num: '1',
                });
            }
        }
    }

    loadSelects = async () => {
        this.setState({ loading: true });
        try {
            const res = await axios.post('admin/discounts/get-selects', { user_id: this.props.user_id });
            if (res.data) {
                const products = res.data.products || [];
                const categories = res.data.categories || [];
                const clients = res.data.clients || [];
                const sellers = res.data.sellers || [];
                const zones = res.data.zones || [];

                let currentDetails = this.props.discount ? (this.props.discount.discount_details || this.props.discount.discountDetails || []) : this.state.details;
                const type = this.props.discount ? this.props.discount.type : this.state.type;

                if (currentDetails && currentDetails.length > 0 && this.props.discount) {
                    currentDetails = JSON.parse(JSON.stringify(currentDetails)); // Deep copy

                    if (type === 'pronto_pago') {
                        if (clients.length > 0 && currentDetails.length >= clients.length) {
                            const first = currentDetails[0];
                            const allSame = currentDetails.every(d => parseFloat(d.percentage) === parseFloat(first.percentage) && parseInt(d.max_days) === parseInt(first.max_days));
                            if (allSame) {
                                currentDetails = [{
                                    is_group: true,
                                    group_label: 'Todos los clientes',
                                    group_type: 'clients',
                                    max_days: first.max_days,
                                    percentage: first.percentage,
                                    items: currentDetails
                                }];
                            }
                        }
                    } else if (type === 'volumen') {
                        const isCategory = currentDetails[0].category_id || currentDetails[0].is_category;
                        if (isCategory && categories.length > 0 && currentDetails.length >= categories.length) {
                            const first = currentDetails[0];
                            const allSame = currentDetails.every(d => parseFloat(d.percentage) === parseFloat(first.percentage) && parseInt(d.min_quantity) === parseInt(first.min_quantity));
                            if (allSame) {
                                currentDetails = [{
                                    is_group: true,
                                    group_label: 'Todas las categorías',
                                    group_type: 'categories',
                                    min_quantity: first.min_quantity,
                                    percentage: first.percentage,
                                    items: currentDetails
                                }];
                            }
                        }
                    } else if (type === 'surtido_volumen') {
                        const isCategory = currentDetails[0].category_id || currentDetails[0].is_category;
                        if (isCategory && categories.length > 0 && currentDetails.length >= categories.length) {
                            currentDetails = [{
                                is_group: true,
                                group_label: 'Todas las categorías',
                                group_type: 'categories',
                                items: currentDetails
                            }];
                        }
                    } else if (type === 'ruta_vendedor') {
                        const byProduct = {};
                        currentDetails.forEach(d => {
                            if (!byProduct[d.product_id]) byProduct[d.product_id] = [];
                            byProduct[d.product_id].push(d);
                        });

                        let newDetails = [];
                        for (const pid in byProduct) {
                            const prodDetails = byProduct[pid];
                            const isZone = prodDetails[0].zone_id || prodDetails[0].is_zone;
                            const isSeller = prodDetails[0].seller_id || prodDetails[0].is_seller;

                            if (isZone && zones.length > 0 && prodDetails.length >= zones.length) {
                                const first = prodDetails[0];
                                const allSame = prodDetails.every(d => parseFloat(d.percentage) === parseFloat(first.percentage));
                                if (allSame) {
                                    newDetails.push({
                                        is_group: true,
                                        group_label: 'Todas las zonas',
                                        group_type: 'zones',
                                        percentage: first.percentage,
                                        product_id: parseInt(pid),
                                        items: prodDetails
                                    });
                                    continue;
                                }
                            } else if (isSeller && sellers.length > 0 && prodDetails.length >= sellers.length) {
                                const first = prodDetails[0];
                                const allSame = prodDetails.every(d => parseFloat(d.percentage) === parseFloat(first.percentage));
                                if (allSame) {
                                    newDetails.push({
                                        is_group: true,
                                        group_label: 'Todos los vendedores',
                                        group_type: 'sellers',
                                        percentage: first.percentage,
                                        product_id: parseInt(pid),
                                        items: prodDetails
                                    });
                                    continue;
                                }
                            }

                            newDetails.push(...prodDetails);
                        }
                        currentDetails = newDetails;
                    }
                }

                this.setState({
                    products,
                    categories,
                    clients,
                    sellers,
                    zones,
                    ruta_vendedor_details: res.data.ruta_vendedor_details || [],
                    details: this.props.discount ? currentDetails : this.state.details,
                    loading: false
                });
            }
        } catch (error) {
            console.error('Error fetching selects:', error);
            this.setState({ loading: false });
        }
    }

    getProductPriceByNum = (product, priceNum) => {
        if (!product || !product.prices || product.prices.length === 0) return 0;
        const idx = priceNum - 1;
        if (product.prices[idx] !== undefined) {
            return product.prices[idx];
        }
        return product.prices[0];
    }

    isProductBultoCajaCestaUnidad = (p) => Globals.checkIsBultoCajaCestaUnidad(p)
    isProductBultoCajaCesta = (p) => this.isProductBultoCajaCestaUnidad(p)


    getProductInfo = (product_id) => {
        const found = this.state.products.find(p => p.id === product_id);
        return found || { name: 'Cargando...', code: '' };
    }

    handleDetailChange = (index, field, value) => {
        if (['percentage', 'min_quantity', 'max_days', 'max_quantity', 'special_price'].includes(field)) {
            if (value !== '' && parseFloat(value) < 0) {
                return;
            }
        }

        this.setState(prevState => {
            const newDetails = [...prevState.details];
            const detail = { ...newDetails[index], [field]: value };
            if (detail.is_group) {
                detail.items = detail.items.map(item => ({
                    ...item,
                    [field]: value
                }));
            }
            newDetails[index] = detail;
            return { details: newDetails };
        });
    }

    handleAddDetail = () => {
        const { surtido_selected_product, surtido_min_quantity, surtido_percentage, surtido_counts_for_calculation, surtido_price_num, details, products } = this.state;

        if (!surtido_selected_product) {
            return Globals.showError('Seleccione un producto');
        }
        if (!surtido_min_quantity) {
            return Globals.showError('Ingrese la cantidad mínima de SKU distintos');
        }
        if (!surtido_percentage) {
            return Globals.showError('Ingrese el % de descuento');
        }

        const price_num = parseInt(surtido_price_num);
        const currentPercentage = parseFloat(surtido_percentage);

        const addNewDetails = (updateExisting = false) => {
            const exists = details.some(d => d.product_id === surtido_selected_product.product.id);
            if (exists) {
                return Globals.showError('El producto ya ha sido agregado a este descuento');
            }

            const newDetail = {
                product_id: surtido_selected_product.product.id,
                min_quantity: parseInt(surtido_min_quantity),
                percentage: currentPercentage,
                counts_for_calculation: 1,
                price_num: price_num,
                price: this.getProductPriceByNum(surtido_selected_product.product, price_num)
            };

            const updatedDetails = updateExisting
                ? details.map(d => ({ ...d, percentage: currentPercentage }))
                : [...details];

            this.setState({
                details: [...updatedDetails, newDetail],
                surtido_selected_product: null
            });
        };

        if (details.length > 0 && details[0].percentage !== currentPercentage) {
            Globals.confirm('Ha modificado el % de descuento. Por regla de negocio, todos los productos en este descuento por surtido deben tener el mismo porcentaje. ¿Desea aplicar este nuevo porcentaje a todos los productos de la lista y agregar el nuevo?', () => {
                addNewDetails(true);
            });
        } else {
            addNewDetails(false);
        }
    }

    getCategoryInfo = (category_id) => {
        const found = this.state.categories.find(c => c.id === category_id);
        return found || { name: 'Cargando...' };
    }

    handleAddDetailVolumen = () => {
        const { volumen_apply_by, volumen_selected_product, volumen_selected_category, volumen_min_quantity, volumen_percentage, volumen_price_num, details, products, categories } = this.state;

        if (volumen_apply_by === 'producto' && !volumen_selected_product) {
            return Globals.showError('Seleccione un producto');
        }
        if (volumen_apply_by === 'categoria' && !volumen_selected_category) {
            return Globals.showError('Seleccione una categoría');
        }
        if (!volumen_min_quantity) {
            return Globals.showError('Ingrese la cantidad mínima');
        }
        if (!volumen_percentage) {
            return Globals.showError('Ingrese el % de descuento');
        }

        const price_num = parseInt(volumen_price_num);
        const min_quantity = parseInt(volumen_min_quantity);
        const percentage = parseFloat(volumen_percentage);

        let newDetailsList = [];

        const processAdditions = (currentDetails = details) => {
            let isGroup = false;
            if (volumen_apply_by === 'producto') {
                const product = volumen_selected_product.product;
                const exists = currentDetails.some(d => d.product_id === product.id);
                if (exists) {
                    return Globals.showError('El producto ya ha sido agregado a este descuento');
                }

                const newDetail = {
                    product_id: product.id,
                    min_quantity: min_quantity,
                    percentage: percentage,
                    price_num: price_num,
                    price: this.getProductPriceByNum(product, price_num),
                    is_category: false
                };

                this.setState({
                    details: [...currentDetails, newDetail],
                    volumen_selected_product: null,
                    volumen_selected_category: null,
                    volumen_min_quantity: '',
                    volumen_percentage: ''
                });
            } else {
                let categoriesToAdd = [];
                if (volumen_selected_category.value === 'all') {
                    isGroup = true;
                    categoriesToAdd = categories;
                } else {
                    categoriesToAdd = [{ id: volumen_selected_category.value }];
                }

                categoriesToAdd.forEach(cat => {
                    const exists = currentDetails.some(d => d.is_group ? d.items.some(i => i.category_id === cat.id) : d.category_id === cat.id);
                    if (!exists) {
                        newDetailsList.push({
                            category_id: cat.id,
                            min_quantity: min_quantity,
                            percentage: percentage,
                            price_num: price_num,
                            price: 0,
                            is_category: true
                        });
                    }
                });

                if (newDetailsList.length === 0) {
                    return Globals.showError(isGroup ? 'Todas las categorías ya han sido agregadas' : 'La categoría ya ha sido agregada a este descuento');
                }

                if (isGroup) {
                    this.setState({
                        details: [...currentDetails, {
                            is_group: true,
                            group_label: 'Todas las categorías',
                            group_type: 'categories',
                            min_quantity: min_quantity,
                            percentage: percentage,
                            items: newDetailsList
                        }],
                        volumen_selected_product: null,
                        volumen_selected_category: null,
                        volumen_min_quantity: '',
                        volumen_percentage: ''
                    });
                } else {
                    this.setState({
                        details: [...currentDetails, ...newDetailsList],
                        volumen_selected_product: null,
                        volumen_selected_category: null,
                        volumen_min_quantity: '',
                        volumen_percentage: ''
                    });
                }
            }
        };

        if (volumen_apply_by === 'producto') {
            const hasCategories = details.some(d => d.category_id || d.is_category);
            if (hasCategories) {
                return Globals.confirm(
                    'Ya existen detalles configurados por categoría. Este descuento por volumen solo puede ser de un tipo a la vez. Al continuar, todos los detalles por categoría serán eliminados y se comenzará con detalles por producto. ¿Desea continuar?',
                    () => {
                        processAdditions([]);
                    }
                );
            }
        } else {
            const hasProducts = details.some(d => d.product_id && !d.is_category);
            if (hasProducts) {
                return Globals.confirm(
                    'Ya existen detalles configurados por producto. Este descuento por volumen solo puede ser de un tipo a la vez. Al continuar, todos los detalles por producto serán eliminados y se comenzará con detalles por categoría. ¿Desea continuar?',
                    () => {
                        processAdditions([]);
                    }
                );
            }
        }

        processAdditions(details);
    }

    handleAddDetailProntoPago = () => {
        const { pronto_pago_days, pronto_pago_percentage, pronto_pago_selected_client, details, clients } = this.state;

        if (!pronto_pago_days) {
            return Globals.showError('Ingrese el plazo de pago');
        }
        if (!pronto_pago_percentage) {
            return Globals.showError('Ingrese el % de descuento');
        }
        if (!pronto_pago_selected_client) {
            return Globals.showError('Seleccione un cliente');
        }

        const max_days = parseInt(pronto_pago_days);
        const percentage = parseFloat(pronto_pago_percentage);
        let newDetailsList = [];

        let clientsToAdd = [];
        let isGroup = false;
        if (pronto_pago_selected_client.value === 'all') {
            isGroup = true;
            clientsToAdd = clients;
        } else {
            clientsToAdd = [{ id: pronto_pago_selected_client.value }];
        }

        clientsToAdd.forEach(client => {
            const exists = details.some(d => d.is_group ? d.items.some(i => i.client_id === client.id) : d.client_id === client.id);
            if (!exists) {
                newDetailsList.push({
                    client_id: client.id,
                    max_days: max_days,
                    percentage: percentage
                });
            }
        });

        if (newDetailsList.length === 0) {
            return Globals.showError(isGroup ? 'Todos los clientes ya han sido agregados' : 'El cliente ya ha sido agregado a este descuento');
        }

        if (isGroup) {
            this.setState({
                details: [...details, {
                    is_group: true,
                    group_label: 'Todos los clientes',
                    group_type: 'clients',
                    max_days: max_days,
                    percentage: percentage,
                    items: newDetailsList
                }],
                pronto_pago_selected_client: null,
                pronto_pago_days: '',
                pronto_pago_percentage: ''
            });
        } else {
            this.setState({
                details: [...details, ...newDetailsList],
                pronto_pago_selected_client: null,
                pronto_pago_days: '',
                pronto_pago_percentage: ''
            });
        }
    }

    handleAddDetailRutaVendedor = () => {
        const { ruta_vendedor_apply_by, ruta_vendedor_selected_zone, ruta_vendedor_selected_seller, ruta_vendedor_selected_product, ruta_vendedor_price_num, ruta_vendedor_percentage, details, zones, sellers, products } = this.state;

        if (ruta_vendedor_apply_by === 'ruta' && !ruta_vendedor_selected_zone) {
            return Globals.showError('Seleccione una zona');
        }
        if (ruta_vendedor_apply_by === 'vendedor' && !ruta_vendedor_selected_seller) {
            return Globals.showError('Seleccione un vendedor');
        }
        if (!ruta_vendedor_selected_product) {
            return Globals.showError('Seleccione un producto');
        }
        if (!ruta_vendedor_percentage) {
            return Globals.showError('Ingrese el % de descuento especial');
        }

        const price_num = parseInt(ruta_vendedor_price_num);
        const percentage = parseFloat(ruta_vendedor_percentage);
        const currentDiscountId = this.props.discount ? this.props.discount.id : null;
        const otherDetails = (this.state.ruta_vendedor_details || []).filter(d => d.discount_id !== currentDiscountId);

        const productsToAdd = [ruta_vendedor_selected_product.product];

        let newDetailsList = [];

        const processAdditions = (currentDetails = details) => {
            let isTargetGroup = false;
            let groupLabel = '';

            if (ruta_vendedor_apply_by === 'ruta') {
                let zonesToAdd = [];
                if (ruta_vendedor_selected_zone.value === 'all') {
                    isTargetGroup = true;
                    zonesToAdd = zones;
                } else {
                    zonesToAdd = [{ id: ruta_vendedor_selected_zone.value }];
                }

                groupLabel = isTargetGroup ? 'Todas las zonas' : '';

                productsToAdd.forEach(product => {
                    const hasSellerForProduct = otherDetails.some(d => d.product_id === product.id && d.seller_id);
                    if (!hasSellerForProduct) {
                        zonesToAdd.forEach(zone => {
                            const exists = currentDetails.some(d => d.is_group ? d.items.some(i => i.product_id === product.id && i.zone_id === zone.id) : (d.product_id === product.id && d.zone_id === zone.id));
                            if (!exists) {
                                newDetailsList.push({
                                    product_id: product.id,
                                    zone_id: zone.id,
                                    percentage: percentage,
                                    price_num: price_num,
                                    price: this.getProductPriceByNum(product, price_num),
                                    is_zone: true
                                });
                            }
                        });
                    }
                });

                if (newDetailsList.length === 0) {
                    return Globals.showError('No se pudieron agregar productos o ya existen. Revise si ya hay descuentos por vendedor configurados en otras promociones para este producto.');
                }
            } else {
                let sellersToAdd = [];
                if (ruta_vendedor_selected_seller.value === 'all') {
                    isTargetGroup = true;
                    sellersToAdd = sellers;
                } else {
                    sellersToAdd = [{ id: ruta_vendedor_selected_seller.value }];
                }

                groupLabel = isTargetGroup ? 'Todos los vendedores' : '';

                productsToAdd.forEach(product => {
                    const hasZoneForProduct = otherDetails.some(d => d.product_id === product.id && d.zone_id);
                    if (!hasZoneForProduct) {
                        sellersToAdd.forEach(seller => {
                            const exists = currentDetails.some(d => d.is_group ? d.items.some(i => i.product_id === product.id && i.seller_id === seller.id) : (d.product_id === product.id && d.seller_id === seller.id));
                            if (!exists) {
                                newDetailsList.push({
                                    product_id: product.id,
                                    seller_id: seller.id,
                                    percentage: percentage,
                                    price_num: price_num,
                                    price: this.getProductPriceByNum(product, price_num),
                                    is_seller: true
                                });
                            }
                        });
                    }
                });

                if (newDetailsList.length === 0) {
                    return Globals.showError('No se pudieron agregar productos o ya existen. Revise si ya hay descuentos por zona configurados en otras promociones para este producto.');
                }
            }

            if (isTargetGroup) {
                this.setState({
                    details: [...currentDetails, {
                        is_group: true,
                        group_label: groupLabel,
                        group_type: ruta_vendedor_apply_by === 'ruta' ? 'zones' : 'sellers',
                        percentage: percentage,
                        product_id: productsToAdd[0].id,
                        items: newDetailsList
                    }],
                    ruta_vendedor_selected_product: null,
                    ruta_vendedor_percentage: ''
                });
            } else {
                this.setState({
                    details: [...currentDetails, ...newDetailsList],
                    ruta_vendedor_selected_product: null,
                    ruta_vendedor_percentage: ''
                });
            }
        };

        if (ruta_vendedor_apply_by === 'ruta') {
            const hasSellers = details.some(d => d.seller_id || d.is_seller);
            if (hasSellers) {
                return Globals.confirm(
                    'Ya existen detalles configurados por vendedor. Este descuento solo puede ser de un tipo a la vez. Al continuar, todos los detalles por vendedor serán eliminados y se comenzará con detalles por zona. ¿Desea continuar?',
                    () => {
                        processAdditions([]);
                    }
                );
            }
        } else {
            const hasZones = details.some(d => d.zone_id || d.is_zone);
            if (hasZones) {
                return Globals.confirm(
                    'Ya existen detalles configurados por zona. Este descuento solo puede ser de un tipo a la vez. Al continuar, todos los detalles por zona serán eliminados y se comenzará con detalles por vendedor. ¿Desea continuar?',
                    () => {
                        processAdditions([]);
                    }
                );
            }
        }

        processAdditions(details);
    }

    handleAddDetailLimiteCantidad = () => {
        const { limite_cantidad_special_price, limite_cantidad_max_quantity, limite_cantidad_selected_product, limite_cantidad_price_num, details, products } = this.state;

        if (!limite_cantidad_special_price) return Globals.showError('Ingrese el precio especial');
        if (!limite_cantidad_max_quantity) return Globals.showError('Ingrese la cantidad máxima');
        if (!limite_cantidad_selected_product) return Globals.showError('Seleccione un producto');

        const price_num = parseInt(limite_cantidad_price_num);
        const max_quantity = parseInt(limite_cantidad_max_quantity);
        const special_price = parseFloat(limite_cantidad_special_price);

        const product = limite_cantidad_selected_product.product;
        const exists = details.some(d => d.product_id === product.id);
        if (exists) {
            return Globals.showError('El producto ya ha sido agregado a este descuento');
        }

        const newDetail = {
            product_id: product.id,
            max_quantity: max_quantity,
            special_price: special_price,
            price_num: price_num,
            price: this.getProductPriceByNum(product, price_num)
        };

        this.setState({
            details: [...details, newDetail],
            limite_cantidad_selected_product: null,
            limite_cantidad_special_price: '',
            limite_cantidad_max_quantity: ''
        });
    }

    handleAddDetailSurtidoVolumen = () => {
        const { surtido_volumen_apply_by, surtido_volumen_selected_product, surtido_volumen_selected_category, details } = this.state;

        if (surtido_volumen_apply_by === 'producto' && !surtido_volumen_selected_product) {
            return Globals.showError('Seleccione un producto');
        }
        if (surtido_volumen_apply_by === 'categoria' && !surtido_volumen_selected_category) {
            return Globals.showError('Seleccione una categoría');
        }

        if (surtido_volumen_apply_by === 'producto') {
            const product = surtido_volumen_selected_product.product;
            if (details.some(d => d.product_id === product.id)) {
                return Globals.showError('El producto ya ha sido agregado a este descuento');
            }
            this.setState({
                details: [...details, { product_id: product.id, is_category: false, price: this.getProductPriceByNum(product, parseInt(this.state.surtido_volumen_price_num)) }],
                surtido_volumen_selected_product: null
            });
        } else {
            let categoriesToAdd = [];
            let isGroup = false;

            if (surtido_volumen_selected_category.value === 'all') {
                isGroup = true;
                categoriesToAdd = this.state.categories;
            } else {
                categoriesToAdd = [{ id: surtido_volumen_selected_category.value }];
            }

            let newDetailsList = [];
            categoriesToAdd.forEach(cat => {
                const exists = details.some(d => d.is_group ? d.items.some(i => i.category_id === cat.id) : d.category_id === cat.id);
                if (!exists) {
                    newDetailsList.push({
                        category_id: cat.id,
                        is_category: true,
                        price: 0
                    });
                }
            });

            if (newDetailsList.length === 0) {
                return Globals.showError(isGroup ? 'Todas las categorías ya han sido agregadas' : 'La categoría ya ha sido agregada a este descuento');
            }

            if (isGroup) {
                this.setState({
                    details: [...details, {
                        is_group: true,
                        group_label: 'Todas las categorías',
                        group_type: 'categories',
                        items: newDetailsList
                    }],
                    surtido_volumen_selected_category: null
                });
            } else {
                this.setState({
                    details: [...details, ...newDetailsList],
                    surtido_volumen_selected_category: null
                });
            }
        }
    }

    handleNext = () => {
        if (!this.state.type) {
            return Globals.showError('Seleccione un tipo de descuento');
        }
        this.setState({ step: 2 });
    }

    handleSave = async () => {
        const { name, type, details } = this.state;
        if (!name.trim()) {
            return Globals.showError('El nombre del descuento es obligatorio');
        }

        const isSurtido = type === 'surtido';
        const isVolumen = type === 'volumen';
        const isProntoPago = type === 'pronto_pago';
        const isRutaVendedor = type === 'ruta_vendedor';
        const isLimiteCantidad = type === 'limite_cantidad';
        const isSurtidoVolumen = type === 'surtido_volumen';
        const isGeneral = type === 'general';

        let flatDetails = [];
        details.forEach(d => {
            if (d.is_group) {
                flatDetails.push(...d.items);
            } else {
                flatDetails.push(d);
            }
        });

        if (isSurtido || isVolumen || isProntoPago || isRutaVendedor || isLimiteCantidad) {
            if (flatDetails.length === 0) {
                return Globals.showError(isSurtido ? 'Debe agregar al menos un producto a la lista' : isVolumen ? 'Debe agregar al menos un producto o categoría a la lista' : isProntoPago ? 'Debe agregar al menos un cliente a la lista' : 'Debe agregar al menos un producto a la lista');
            }
        }

        if (isSurtido) {
            const minQuantity = parseInt(this.state.surtido_min_quantity) || 1;
            const validProductsCount = flatDetails.length;
            if (validProductsCount < minQuantity) {
                return Globals.showError(`Para el descuento por surtido, debes agregar al menos ${minQuantity} productos distintos.`);
            }
        }

        let sv_final_details = [];
        if (isSurtidoVolumen) {
            if (!this.state.surtido_volumen_min_sku) return Globals.showError('Debe ingresar la cantidad mínima de SKU distintos');
            if (!this.state.surtido_volumen_min_bultos) return Globals.showError('Debe ingresar la cantidad mínima total');
            if (!this.state.surtido_volumen_percentage_one) return Globals.showError('Debe ingresar el % al cumplir una condición');
            if (!this.state.surtido_volumen_percentage_both) return Globals.showError('Debe ingresar el % al cumplir ambas condiciones');

            if (this.state.surtido_volumen_scope === 'seleccionados' && flatDetails.length === 0) {
                return Globals.showError('Debe agregar al menos un producto o categoría a la lista de participantes');
            }

            if (this.state.surtido_volumen_scope === 'todos') {
                const excludedIds = this.state.surtido_volumen_excluded_products.map(p => p.id);
                this.state.products.forEach(p => {
                    const isBulto = this.isProductBultoCajaCestaUnidad(p);
                    if (!excludedIds.includes(p.id) && isBulto) {
                        sv_final_details.push({
                            product_id: p.id,
                            category_id: null,
                            min_sku: parseInt(this.state.surtido_volumen_min_sku),
                            min_bultos: parseInt(this.state.surtido_volumen_min_bultos),
                            percentage_one_condition: parseFloat(this.state.surtido_volumen_percentage_one),
                            percentage_both_conditions: parseFloat(this.state.surtido_volumen_percentage_both),
                            counts_for_calculation: 1,
                            price: this.getProductPriceByNum(p, parseInt(this.state.surtido_volumen_price_num)),
                            price_num: parseInt(this.state.surtido_volumen_price_num)
                        });
                    }
                });
            } else {
                sv_final_details = flatDetails.map(d => ({
                    product_id: d.product_id || null,
                    category_id: d.category_id || null,
                    min_sku: parseInt(this.state.surtido_volumen_min_sku),
                    min_bultos: parseInt(this.state.surtido_volumen_min_bultos),
                    percentage_one_condition: parseFloat(this.state.surtido_volumen_percentage_one),
                    percentage_both_conditions: parseFloat(this.state.surtido_volumen_percentage_both),
                    counts_for_calculation: 1,
                    price: d.price || 0,
                    price_num: parseInt(this.state.surtido_volumen_price_num)
                }));
            }
        }

        Globals.setLoading();
        try {
            const payload = {
                id: this.props.discount ? this.props.discount.id : null,
                user_id: this.props.user_id,
                name: name,
                type: type,
                details: isSurtido ? flatDetails.map(d => ({
                    product_id: d.product_id,
                    min_quantity: parseInt(this.state.surtido_min_quantity) || 1,
                    percentage: d.percentage,
                    counts_for_calculation: 1,
                    price: d.price,
                    price_num: d.price_num
                })) : isVolumen ? flatDetails.map(d => ({
                    product_id: d.product_id || null,
                    category_id: d.category_id || null,
                    min_quantity: d.min_quantity,
                    percentage: d.percentage,
                    price: d.price || 0,
                    price_num: d.price_num || 1
                })) : isProntoPago ? flatDetails.map(d => ({
                    client_id: d.client_id,
                    max_days: d.max_days,
                    percentage: d.percentage
                })) : isRutaVendedor ? flatDetails.map(d => ({
                    product_id: d.product_id,
                    zone_id: d.zone_id || null,
                    seller_id: d.seller_id || null,
                    percentage: d.percentage,
                    price: d.price || 0,
                    price_num: d.price_num || 1
                })) : isLimiteCantidad ? flatDetails.map(d => ({
                    product_id: d.product_id,
                    max_quantity: d.max_quantity,
                    special_price: d.special_price,
                    price: d.price || 0,
                    price_num: d.price_num || 1
                })) : isSurtidoVolumen ? sv_final_details : null
            };

            const res = await axios.post('admin/discounts/create-or-update', payload);

            if (res.data.success) {
                Globals.showSuccess(res.data.message);
                this.props.onSuccess();
            } else {
                Globals.showError(res.data.error || 'Ocurrió un error al guardar');
            }
        } catch (error) {
            console.log(error);
            const msg = error.response?.data?.error || 'Ocurrió un error inesperado';
            Globals.showError(msg);
        }
        Globals.quitLoading();
    }

    render() {
        const { show, onHide, discountTypes } = this.props;
        const { step, type, name, details, products } = this.state;

        const isGeneral = type === 'general';
        const isSurtido = type === 'surtido';
        const isVolumen = type === 'volumen';
        const isProntoPago = type === 'pronto_pago';
        const isRutaVendedor = type === 'ruta_vendedor';
        const isLimiteCantidad = type === 'limite_cantidad';
        const isSurtidoVolumen = type === 'surtido_volumen';

        return (
            <BModal show={show} onHide={onHide} size="lg" centered>
                <BModal.Header closeButton style={{ borderBottom: 'none', paddingBottom: 0 }}>
                    <BModal.Title style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                        {step === 2 && !this.props.discount && (
                            <span
                                style={{ cursor: 'pointer', marginRight: '10px' }}
                                onClick={() => this.setState({ step: 1 })}
                            >
                                <Icon name="arrow-left" />
                            </span>
                        )}
                        {this.props.discount
                            ? `Editar descuento ${isSurtido ? 'por surtido' : isVolumen ? 'por volumen' : isProntoPago ? 'por pronto pago' : isLimiteCantidad ? 'por límite de cantidad' : isRutaVendedor ? 'por zona/vendedor' : isSurtidoVolumen ? 'por surtido y volumen' : ''}`
                            : `Crear descuento ${isSurtido ? 'por surtido' : isVolumen ? 'por volumen' : isProntoPago ? 'por pronto pago' : isLimiteCantidad ? 'por límite de cantidad' : isRutaVendedor ? 'por zona/vendedor' : isSurtidoVolumen ? 'por surtido y volumen' : ''}`}
                    </BModal.Title>
                </BModal.Header>
                <BModal.Body style={{ paddingTop: 0 }}>
                    <div className="d-flex justify-content-center align-items-center mb-5 mt-2">
                        <span style={{ color: step === 1 ? '#007bff' : '#ccc', fontWeight: step === 1 ? 'bold' : 'normal' }}>
                            Tipo de descuento
                        </span>
                        <div style={{ height: '2px', width: '80px', background: '#ccc', margin: '0 15px' }}></div>
                        <span style={{ color: step === 2 ? '#007bff' : '#ccc', fontWeight: step === 2 ? 'bold' : 'normal' }}>
                            Configuración
                        </span>
                    </div>

                    {step === 1 && (
                        <div>
                            <p style={{ fontWeight: 'bold' }}>Seleccione el tipo de descuento a crear</p>
                            <Select
                                color=""
                                className="material"
                                labelClass="material"
                                options={discountTypes.filter(t => t.value !== '')}
                                value={type}
                                onChange={(e) => this.setState({ type: e.target.value })}
                            />
                        </div>
                    )}

                    {step === 2 && (
                        <div>
                            {isGeneral ? (
                                <Input
                                    color=""
                                    className="material"
                                    labelClass="material"
                                    label="Nombre del descuento"
                                    value={name}
                                    onChange={(e) => this.setState({ name: e.target.value })}
                                />
                            ) : isSurtido ? (
                                <div>
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <Input
                                                color=""
                                                className="material"
                                                labelClass="material"
                                                label="Nombre del descuento"
                                                placeholder="Ejemplo: Descuento Surtido Verano"
                                                value={name}
                                                onChange={(e) => this.setState({ name: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <Input
                                                color=""
                                                className="material"
                                                labelClass="material"
                                                label="Cantidad mínima de SKU distintos"
                                                placeholder="Ejemplo: 5"
                                                type="number"
                                                min="1"
                                                step="1"
                                                onKeyDown={(e) => {
                                                    if (['.', ',', 'e', 'E', '-', '+'].includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={this.state.surtido_min_quantity}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/\D/g, '');
                                                    const updatedDetails = this.state.details.map(d => ({
                                                        ...d,
                                                        min_quantity: val ? parseInt(val) : ''
                                                    }));
                                                    this.setState({
                                                        surtido_min_quantity: val,
                                                        details: updatedDetails
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                color=""
                                                className="material"
                                                labelClass="material"
                                                label="% de descuento"
                                                placeholder="Ejemplo: 5"
                                                type="number"
                                                value={this.state.surtido_percentage}
                                                onChange={(e) => this.setState({ surtido_percentage: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3 align-items-center">
                                        <div className="col-md-12">
                                            <SelectSearch
                                                label="SKU a los que aplica el descuento"
                                                placeholder="Seleccionar productos"
                                                options={products.map((p) => ({
                                                    value: p.id,
                                                    label: `${p.name} (${p.code})`,
                                                    product: p
                                                }))}
                                                value={this.state.surtido_selected_product}
                                                onChange={(data) => this.setState({ surtido_selected_product: data })}
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-center mb-4">
                                        <Button
                                            color=" "
                                            className="primary d-flex align-items-center justify-content-center"
                                            style={{ gap: '5px' }}
                                            onClick={this.handleAddDetail}
                                        >
                                            <Icon name="plus" /> Agregar
                                        </Button>
                                    </div>

                                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                        {details.length > 0 ? (
                                            <Table
                                                header={['Producto', 'Código', '% de descuento', '']}
                                                data={details.length}
                                            >
                                                {details.map((detail, index) => {
                                                    const prodInfo = this.getProductInfo(detail.product_id);
                                                    return (
                                                        <tr key={index}>
                                                            <td>{prodInfo.name}</td>
                                                            <td>{prodInfo.code}</td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    style={{ width: '80px', padding: '2px 5px', height: '30px' }}
                                                                    value={detail.percentage || ''}
                                                                    onChange={(e) => this.handleDetailChange(index, 'percentage', e.target.value)}
                                                                />
                                                            </td>
                                                            <td style={{ textAlign: 'right' }}>
                                                                <span
                                                                    style={{ cursor: 'pointer', color: '#dc3545' }}
                                                                    onClick={() => {
                                                                        const updatedDetails = [...details];
                                                                        updatedDetails.splice(index, 1);
                                                                        this.setState({ details: updatedDetails });
                                                                    }}
                                                                >
                                                                    <Icon name="trash" />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </Table>
                                        ) : (
                                            <div className="alert alert-info text-center">
                                                No hay productos agregados.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : isVolumen ? (
                                <div>
                                    <Input
                                        color=""
                                        className="material"
                                        labelClass="material"
                                        label="Nombre del descuento"
                                        value={name}
                                        onChange={(e) => this.setState({ name: e.target.value })}
                                    />

                                    <div className="d-flex justify-content-center align-items-center mb-4 mt-3">
                                        <span style={{ fontWeight: 'bold', marginRight: '20px' }}>Aplicar por</span>
                                        <div className="d-flex align-items-center" style={{ gap: '20px' }}>
                                            <div
                                                className="d-flex align-items-center"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => this.setState({ volumen_apply_by: 'producto' })}
                                            >
                                                <span style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '50%',
                                                    border: '2px solid #ccc',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginRight: '8px',
                                                    backgroundColor: this.state.volumen_apply_by === 'producto' ? '#2ecc71' : 'transparent',
                                                    borderColor: this.state.volumen_apply_by === 'producto' ? '#2ecc71' : '#ccc'
                                                }}>
                                                    {this.state.volumen_apply_by === 'producto' && (
                                                        <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#fff' }}></span>
                                                    )}
                                                </span>
                                                <span>Producto</span>
                                            </div>
                                            <div
                                                className="d-flex align-items-center"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => this.setState({ volumen_apply_by: 'categoria' })}
                                            >
                                                <span style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '50%',
                                                    border: '2px solid #ccc',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginRight: '8px',
                                                    backgroundColor: this.state.volumen_apply_by === 'categoria' ? '#2ecc71' : 'transparent',
                                                    borderColor: this.state.volumen_apply_by === 'categoria' ? '#2ecc71' : '#ccc'
                                                }}>
                                                    {this.state.volumen_apply_by === 'categoria' && (
                                                        <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#fff' }}></span>
                                                    )}
                                                </span>
                                                <span>Categoría</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            {this.state.volumen_apply_by === 'producto' ? (
                                                <SelectSearch
                                                    label="Producto"
                                                    placeholder="Seleccionar productos"
                                                    options={products.map((p) => ({
                                                        value: p.id,
                                                        label: `${p.name} (${p.code})`,
                                                        product: p
                                                    }))}
                                                    value={this.state.volumen_selected_product}
                                                    onChange={(data) => this.setState({ volumen_selected_product: data })}
                                                />
                                            ) : (
                                                <SelectSearch
                                                    label="Categoría"
                                                    placeholder="Seleccionar categoría"
                                                    options={[{ value: 'all', label: 'Todas las categorías' }, ...this.state.categories.map((c) => ({
                                                        value: c.id,
                                                        label: c.name
                                                    }))]}
                                                    value={this.state.volumen_selected_category}
                                                    onChange={(data) => this.setState({ volumen_selected_category: data })}
                                                />
                                            )}
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                color=""
                                                className="material"
                                                labelClass="material"
                                                label="Cantidad mínima"
                                                placeholder="Ejemplo: 5"
                                                type="number"
                                                onKeyDown={(e) => {
                                                    if (['.', ',', 'e', 'E', '-', '+'].includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={this.state.volumen_min_quantity}
                                                onChange={(e) => this.setState({ volumen_min_quantity: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <Input
                                                color=""
                                                className="material"
                                                labelClass="material"
                                                label="% de descuento"
                                                placeholder="Ejemplo: 5"
                                                type="number"
                                                value={this.state.volumen_percentage}
                                                onChange={(e) => this.setState({ volumen_percentage: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-center mb-3 mt-3">
                                        <Button color="success" onClick={this.handleAddDetailVolumen} type="button">
                                            <Icon name="plus" /> Agregar
                                        </Button>
                                    </div>

                                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                        {details.length > 0 ? (
                                            <Table
                                                header={['Producto / Categoría', 'Código', 'Cantidad Mínima', '% de descuento', '']}
                                                data={details.length}
                                            >
                                                {details.map((detail, index) => {
                                                    const isCat = detail.category_id || detail.is_category;
                                                    const name = detail.is_group ? `${detail.group_label}` : isCat ? `[Categoría] ${this.getCategoryInfo(detail.category_id).name}` : this.getProductInfo(detail.product_id).name;
                                                    const code = detail.is_group ? '-' : isCat ? '-' : this.getProductInfo(detail.product_id).code;
                                                    return (
                                                        <tr key={index}>
                                                            <td>{name}</td>
                                                            <td>{code}</td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    style={{ width: '80px', padding: '2px 5px', height: '30px' }}
                                                                    value={detail.min_quantity || ''}
                                                                    onChange={(e) => this.handleDetailChange(index, 'min_quantity', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    style={{ width: '80px', padding: '2px 5px', height: '30px' }}
                                                                    value={detail.percentage || ''}
                                                                    onChange={(e) => this.handleDetailChange(index, 'percentage', e.target.value)}
                                                                />
                                                            </td>
                                                            <td style={{ textAlign: 'right' }}>
                                                                <span
                                                                    style={{ cursor: 'pointer', color: '#dc3545' }}
                                                                    onClick={() => {
                                                                        const updatedDetails = [...details];
                                                                        updatedDetails.splice(index, 1);
                                                                        this.setState({ details: updatedDetails });
                                                                    }}
                                                                >
                                                                    <Icon name="trash" />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </Table>
                                        ) : (
                                            <div className="alert alert-info text-center">
                                                No hay productos ni categorías agregados.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : isProntoPago ? (
                                <div>
                                    <Input
                                        color=""
                                        className="material"
                                        labelClass="material"
                                        label="Nombre del descuento"
                                        value={name}
                                        onChange={(e) => this.setState({ name: e.target.value })}
                                    />

                                    <div className="row mb-3 mt-3">
                                        <div className="col-md-6">
                                            <Input
                                                color=""
                                                className="material"
                                                labelClass="material"
                                                label="Plazo de pago para tener descuento (días)"
                                                placeholder="Ejemplo: 5"
                                                type="number"
                                                value={this.state.pronto_pago_days}
                                                onKeyDown={(e) => {
                                                    if (['.', ',', 'e', 'E', '-', '+'].includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onChange={(e) => this.setState({ pronto_pago_days: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                color=""
                                                className="material"
                                                labelClass="material"
                                                label="% de descuento"
                                                placeholder="Ejemplo: 5"
                                                type="number"
                                                value={this.state.pronto_pago_percentage}
                                                onChange={(e) => this.setState({ pronto_pago_percentage: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <SelectSearch
                                                label="Aplicar al cliente"
                                                placeholder="Buscar cliente"
                                                options={[{ value: 'all', label: 'Todos los clientes' }, ...this.state.clients.map((c) => ({
                                                    value: c.id,
                                                    label: c.name,
                                                    client: c
                                                }))]}
                                                value={this.state.pronto_pago_selected_client}
                                                onChange={(data) => this.setState({ pronto_pago_selected_client: data })}
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-center mb-3 mt-3">
                                        <Button color="success" onClick={this.handleAddDetailProntoPago} type="button">
                                            <Icon name="plus" /> Agregar
                                        </Button>
                                    </div>

                                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                        {details.length > 0 ? (
                                            <Table
                                                header={['Cliente', '% de descuento', 'Plazo de pago para tener descuento (días)', '']}
                                                data={details.length}
                                            >
                                                {details.map((detail, index) => {
                                                    const clientName = detail.is_group ? `${detail.group_label}` : this.state.clients.find(c => c.id === detail.client_id)?.name || 'Desconocido';
                                                    return (
                                                        <tr key={index}>
                                                            <td>{clientName}</td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    style={{ width: '80px', padding: '2px 5px', height: '30px' }}
                                                                    value={detail.percentage || ''}
                                                                    onChange={(e) => this.handleDetailChange(index, 'percentage', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    style={{ width: '100px', padding: '2px 5px', height: '30px' }}
                                                                    value={detail.max_days || ''}
                                                                    onChange={(e) => this.handleDetailChange(index, 'max_days', e.target.value)}
                                                                />
                                                            </td>
                                                            <td style={{ textAlign: 'right' }}>
                                                                <span
                                                                    style={{ cursor: 'pointer', color: '#dc3545' }}
                                                                    onClick={() => {
                                                                        const updatedDetails = [...details];
                                                                        updatedDetails.splice(index, 1);
                                                                        this.setState({ details: updatedDetails });
                                                                    }}
                                                                >
                                                                    <Icon name="trash" />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </Table>
                                        ) : (
                                            <div className="alert alert-info text-center">
                                                No hay clientes agregados.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : isRutaVendedor ? (
                                <div>
                                    <Input
                                        color=""
                                        className="material"
                                        labelClass="material"
                                        label="Nombre del descuento"
                                        value={name}
                                        onChange={(e) => this.setState({ name: e.target.value })}
                                    />

                                    <div className="row mb-3 mt-3">
                                        <div className="col-md-6">
                                            <span style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px', fontSize: '14px' }}>¿A quien aplica el descuento?</span>
                                            <div className="d-flex align-items-center" style={{ gap: '20px' }}>
                                                <div
                                                    className="d-flex align-items-center"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => this.setState({ ruta_vendedor_apply_by: 'ruta' })}
                                                >
                                                    <span style={{
                                                        width: '20px',
                                                        height: '20px',
                                                        borderRadius: '50%',
                                                        border: '2px solid #ccc',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginRight: '8px',
                                                        backgroundColor: this.state.ruta_vendedor_apply_by === 'ruta' ? '#2ecc71' : 'transparent',
                                                        borderColor: this.state.ruta_vendedor_apply_by === 'ruta' ? '#2ecc71' : '#ccc'
                                                    }}>
                                                        {this.state.ruta_vendedor_apply_by === 'ruta' && (
                                                            <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#fff' }}></span>
                                                        )}
                                                    </span>
                                                    <span>Zona</span>
                                                </div>
                                                <div
                                                    className="d-flex align-items-center"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => this.setState({ ruta_vendedor_apply_by: 'vendedor' })}
                                                >
                                                    <span style={{
                                                        width: '20px',
                                                        height: '20px',
                                                        borderRadius: '50%',
                                                        border: '2px solid #ccc',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginRight: '8px',
                                                        backgroundColor: this.state.ruta_vendedor_apply_by === 'vendedor' ? '#2ecc71' : 'transparent',
                                                        borderColor: this.state.ruta_vendedor_apply_by === 'vendedor' ? '#2ecc71' : '#ccc'
                                                    }}>
                                                        {this.state.ruta_vendedor_apply_by === 'vendedor' && (
                                                            <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#fff' }}></span>
                                                        )}
                                                    </span>
                                                    <span>Vendedor</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            {this.state.ruta_vendedor_apply_by === 'ruta' ? (
                                                <SelectSearch
                                                    label="Zona a la que aplica"
                                                    placeholder="Buscar Zona"
                                                    options={[{ value: 'all', label: 'Todas las zonas' }, ...this.state.zones.map((z) => ({
                                                        value: z.id,
                                                        label: z.name
                                                    }))]}
                                                    value={this.state.ruta_vendedor_selected_zone}
                                                    onChange={(data) => this.setState({ ruta_vendedor_selected_zone: data })}
                                                />
                                            ) : (
                                                <SelectSearch
                                                    label="Vendedor al que aplica"
                                                    placeholder="Buscar vendedor"
                                                    options={[{ value: 'all', label: 'Todos los vendedores' }, ...this.state.sellers.map((s) => ({
                                                        value: s.id,
                                                        label: s.name
                                                    }))]}
                                                    value={this.state.ruta_vendedor_selected_seller}
                                                    onChange={(data) => this.setState({ ruta_vendedor_selected_seller: data })}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <SelectSearch
                                                label="Producto con descuento especial"
                                                placeholder="Seleccionar productos"
                                                options={products.map((p) => ({
                                                    value: p.id,
                                                    label: `${p.name} (${p.code})`,
                                                    product: p
                                                }))}
                                                value={this.state.ruta_vendedor_selected_product}
                                                onChange={(data) => this.setState({ ruta_vendedor_selected_product: data })}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <Input
                                                color=""
                                                className="material"
                                                labelClass="material"
                                                label="% de descuento"
                                                placeholder="Ejemplo: 5"
                                                type="number"
                                                value={this.state.ruta_vendedor_percentage}
                                                onChange={(e) => this.setState({ ruta_vendedor_percentage: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-center mb-4 mt-3">
                                        <Button color=" " className="primary d-flex align-items-center justify-content-center" style={{ gap: '5px' }} onClick={this.handleAddDetailRutaVendedor} type="button">
                                            <Icon name="plus" /> Agregar
                                        </Button>
                                    </div>

                                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                        {details.length > 0 ? (
                                            <Table
                                                header={['Zona', 'Vendedor', 'Productos', 'Código', '% de descuento', '']}
                                                data={details.length}
                                            >
                                                {details.map((detail, index) => {
                                                    const isZone = detail.zone_id || detail.is_zone;
                                                    const isSeller = detail.seller_id || detail.is_seller;
                                                    let routeName = detail.is_group && detail.group_type === 'zones' ? `Todas las zonas` : isZone ? (this.state.zones.find(z => z.id === detail.zone_id)?.name || '-') : '-';
                                                    let sellerName = detail.is_group && detail.group_type === 'sellers' ? `Todos los vendedores` : isSeller ? (this.state.sellers.find(s => s.id === detail.seller_id)?.name || '-') : '-';
                                                    let prodName = this.getProductInfo(detail.product_id).name;
                                                    let prodCode = this.getProductInfo(detail.product_id).code;
                                                    return (
                                                        <tr key={index}>
                                                            <td>{routeName}</td>
                                                            <td>{sellerName}</td>
                                                            <td>{prodName}</td>
                                                            <td>{prodCode}</td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    style={{ width: '80px', padding: '2px 5px', height: '30px' }}
                                                                    value={detail.percentage || ''}
                                                                    onChange={(e) => this.handleDetailChange(index, 'percentage', e.target.value)}
                                                                />
                                                            </td>
                                                            <td style={{ textAlign: 'right' }}>
                                                                <span
                                                                    style={{ cursor: 'pointer', color: '#dc3545' }}
                                                                    onClick={() => {
                                                                        const updatedDetails = [...details];
                                                                        updatedDetails.splice(index, 1);
                                                                        this.setState({ details: updatedDetails });
                                                                    }}
                                                                >
                                                                    <Icon name="trash" />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </Table>
                                        ) : (
                                            <div className="alert alert-info text-center">
                                                No has agregado ningún producto
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : isLimiteCantidad ? (
                                <div>
                                    <Input
                                        color=""
                                        className="material"
                                        labelClass="material"
                                        label="Nombre del descuento"
                                        value={name}
                                        onChange={(e) => this.setState({ name: e.target.value })}
                                    />

                                    <div className="row mb-3 mt-3">
                                        <div className="col-md-6">
                                            <Input
                                                color=""
                                                className="material"
                                                labelClass="material"
                                                label="Precio especial del producto ($)"
                                                placeholder="Ejemplo: 100,00"
                                                type="number"
                                                value={this.state.limite_cantidad_special_price}
                                                onChange={(e) => this.setState({ limite_cantidad_special_price: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                color=""
                                                className="material"
                                                labelClass="material"
                                                label="Cantidad máxima de producto a la que aplica"
                                                placeholder="Ejemplo: 5"
                                                type="number"
                                                value={this.state.limite_cantidad_max_quantity}
                                                onChange={(e) => this.setState({ limite_cantidad_max_quantity: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <SelectSearch
                                                label="SKU con precio especial"
                                                placeholder="Buscar producto por nombre o código"
                                                options={products.map((p) => ({
                                                    value: p.id,
                                                    label: `${p.name} (${p.code})`,
                                                    product: p
                                                }))}
                                                value={this.state.limite_cantidad_selected_product}
                                                onChange={(data) => this.setState({ limite_cantidad_selected_product: data })}
                                            />
                                        </div>
                                        {this.state.limite_cantidad_selected_product && (() => {
                                            const prodObj = this.getProductInfo(this.state.limite_cantidad_selected_product.product.id) || this.state.limite_cantidad_selected_product.product;
                                            const currentPrice = prodObj.default_price_value || this.getProductPriceByNum(prodObj, 1) || prodObj.price || 0;
                                            return (
                                                <div className="col-md-6 d-flex align-items-center">
                                                    <div style={{ marginTop: '20px', padding: '10px 15px', backgroundColor: '#f8f9fa', borderRadius: '5px', border: '1px solid #e9ecef', width: '100%' }}>
                                                        <span style={{ fontWeight: '500', color: '#6c757d' }}>Precio de venta actual: </span>
                                                        <span style={{ fontSize: '1.1em', color: '#28a745', fontWeight: 'bold', marginLeft: '5px' }}>
                                                            ${currentPrice}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </div>

                                    <div className="d-flex justify-content-center mb-4 mt-3">
                                        <Button color=" " className="primary d-flex align-items-center justify-content-center" style={{ gap: '5px' }} onClick={this.handleAddDetailLimiteCantidad} type="button">
                                            <Icon name="plus" /> Agregar
                                        </Button>
                                    </div>

                                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                        {details.length > 0 ? (
                                            <Table
                                                header={['Producto', 'Código', 'Cantidad máxima de producto', 'Precio especial ($)', '']}
                                                data={details.length}
                                            >
                                                {details.map((detail, index) => {
                                                    const prodInfo = this.getProductInfo(detail.product_id);
                                                    return (
                                                        <tr key={index}>
                                                            <td>{prodInfo.name}</td>
                                                            <td>{prodInfo.code}</td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    style={{ width: '100px', padding: '2px 5px', height: '30px' }}
                                                                    value={detail.max_quantity || ''}
                                                                    onChange={(e) => this.handleDetailChange(index, 'max_quantity', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    style={{ width: '100px', padding: '2px 5px', height: '30px' }}
                                                                    value={detail.special_price || ''}
                                                                    onChange={(e) => this.handleDetailChange(index, 'special_price', e.target.value)}
                                                                />
                                                            </td>
                                                            <td style={{ textAlign: 'right' }}>
                                                                <span
                                                                    style={{ cursor: 'pointer', color: '#dc3545' }}
                                                                    onClick={() => {
                                                                        const updatedDetails = [...details];
                                                                        updatedDetails.splice(index, 1);
                                                                        this.setState({ details: updatedDetails });
                                                                    }}
                                                                >
                                                                    <Icon name="trash" />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </Table>
                                        ) : (
                                            <div className="alert alert-info text-center">
                                                No hay productos agregados.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : isSurtidoVolumen ? (
                                <div>
                                    <Input
                                        color=""
                                        className="material"
                                        labelClass="material"
                                        label="Nombre del descuento"
                                        value={name}
                                        onChange={(e) => this.setState({ name: e.target.value })}
                                    />

                                    <div className="row mb-3 mt-3">
                                        <div className="col-md-6">
                                            <p style={{ fontWeight: 'bold', fontSize: '13px', color: '#888', marginBottom: '5px' }}>Aplicar por:</p>
                                            <div className="d-flex" style={{ gap: '20px' }}>
                                                <div className="custom-control custom-radio">
                                                    <input type="radio" id="sv_apply_prod" name="sv_apply" className="custom-control-input"
                                                        checked={this.state.surtido_volumen_apply_by === 'producto'}
                                                        onChange={() => {
                                                            if (this.state.details.length > 0 && this.state.surtido_volumen_apply_by === 'categoria') {
                                                                Globals.confirm('Al cambiar a producto, se limpiará la lista de categorías actual. ¿Desea continuar?', () => {
                                                                    this.setState({ surtido_volumen_apply_by: 'producto', surtido_volumen_selected_category: null, details: [] });
                                                                });
                                                            } else {
                                                                this.setState({ surtido_volumen_apply_by: 'producto', surtido_volumen_selected_category: null });
                                                            }
                                                        }}
                                                    />
                                                    <label className="custom-control-label" htmlFor="sv_apply_prod">Producto</label>
                                                </div>
                                                <div className="custom-control custom-radio">
                                                    <input type="radio" id="sv_apply_cat" name="sv_apply" className="custom-control-input"
                                                        checked={this.state.surtido_volumen_apply_by === 'categoria'}
                                                        onChange={() => {
                                                            if (this.state.details.length > 0 && this.state.surtido_volumen_apply_by === 'producto') {
                                                                Globals.confirm('Al cambiar a categoría, se limpiará la lista de productos actual. ¿Desea continuar?', () => {
                                                                    this.setState({ surtido_volumen_apply_by: 'categoria', surtido_volumen_selected_product: null, details: [], surtido_volumen_scope: 'seleccionados' });
                                                                });
                                                            } else {
                                                                this.setState({ surtido_volumen_apply_by: 'categoria', surtido_volumen_selected_product: null, surtido_volumen_scope: 'seleccionados' });
                                                            }
                                                        }}
                                                    />
                                                    <label className="custom-control-label" htmlFor="sv_apply_cat">Categoría</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {this.state.surtido_volumen_apply_by === 'producto' && (
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <Select
                                                    color=""
                                                    className="material"
                                                    labelClass="material"
                                                    label="Alcance de productos"
                                                    options={[{ value: 'todos', label: 'Todos los productos' }, { value: 'seleccionados', label: 'Productos seleccionados' }]}
                                                    value={this.state.surtido_volumen_scope}
                                                    onChange={(e) => this.setState({ surtido_volumen_scope: e.target.value, details: [], surtido_volumen_excluded_products: [] })}
                                                />
                                            </div>
                                            {this.state.surtido_volumen_scope === 'todos' && (
                                                <div className="col-md-6">
                                                    <SelectSearch
                                                        label="Buscar productos para excluir"
                                                        placeholder="Buscar por código o nombre..."
                                                        options={products.filter(p => this.isProductBultoCajaCestaUnidad(p)).map((p) => ({
                                                            value: p.id,
                                                            label: `${p.name} (${p.code})`,
                                                            product: p
                                                        }))}
                                                        value={null}
                                                        onChange={(data) => {
                                                            const exists = this.state.surtido_volumen_excluded_products.some(p => p.id === data.product.id);
                                                            if (!exists) {
                                                                this.setState({ surtido_volumen_excluded_products: [...this.state.surtido_volumen_excluded_products, data.product] });
                                                            }
                                                        }}
                                                    />
                                                    <div className="mt-2 d-flex flex-wrap" style={{ gap: '5px' }}>
                                                        {this.state.surtido_volumen_excluded_products.map((prod, idx) => (
                                                            <span key={idx} className="badge badge-secondary p-2 d-flex align-items-center">
                                                                {prod.name}
                                                                <Icon name="x" className="ml-2" style={{ cursor: 'pointer' }} onClick={() => {
                                                                    const newEx = [...this.state.surtido_volumen_excluded_products];
                                                                    newEx.splice(idx, 1);
                                                                    this.setState({ surtido_volumen_excluded_products: newEx });
                                                                }} />
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {this.state.surtido_volumen_scope === 'seleccionados' && (
                                        <div className="row mb-3 align-items-end">
                                            <div className="col-md-6">
                                                {this.state.surtido_volumen_apply_by === 'producto' ? (
                                                    <SelectSearch
                                                        label="Buscar producto"
                                                        placeholder="Buscar por código o nombre..."
                                                        options={products.filter(p => this.isProductBultoCajaCestaUnidad(p)).map((p) => ({
                                                            value: p.id,
                                                            label: `${p.name} (${p.code})`,
                                                            product: p
                                                        }))}
                                                        value={this.state.surtido_volumen_selected_product}
                                                        onChange={(data) => this.setState({ surtido_volumen_selected_product: data })}
                                                    />
                                                ) : (
                                                    <SelectSearch
                                                        label="Buscar categoría"
                                                        placeholder="Seleccione la categoría..."
                                                        options={[{ value: 'all', label: 'Todas las categorías' }, ...this.state.categories.map((c) => ({
                                                            value: c.id,
                                                            label: c.name
                                                        }))]}
                                                        value={this.state.surtido_volumen_selected_category}
                                                        onChange={(data) => this.setState({ surtido_volumen_selected_category: data })}
                                                    />
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <Button color="success" onClick={this.handleAddDetailSurtidoVolumen} type="button">
                                                    <Icon name="plus" /> Agregar
                                                </Button>
                                            </div>
                                        </div>
                                    )}

                                    {this.state.surtido_volumen_scope === 'seleccionados' && (
                                        <div style={{ maxHeight: '200px', overflowY: 'auto', marginBottom: '20px' }}>
                                            {details.length > 0 ? (
                                                <Table
                                                    header={['Producto / Categoría', 'Código', '']}
                                                    data={details.length}
                                                >
                                                    {details.map((detail, index) => {
                                                        const isCat = detail.category_id || detail.is_category || (detail.is_group && detail.group_type === 'categories');
                                                        const name = detail.is_group ? `${detail.group_label}` : isCat ? `[Categoría] ${this.getCategoryInfo(detail.category_id).name}` : this.getProductInfo(detail.product_id).name;
                                                        const code = detail.is_group ? '-' : isCat ? '-' : this.getProductInfo(detail.product_id).code;
                                                        return (
                                                            <tr key={index}>
                                                                <td>{name}</td>
                                                                <td>{code}</td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    <span
                                                                        style={{ cursor: 'pointer', color: '#dc3545' }}
                                                                        onClick={() => {
                                                                            const updatedDetails = [...details];
                                                                            updatedDetails.splice(index, 1);
                                                                            this.setState({ details: updatedDetails });
                                                                        }}
                                                                    >
                                                                        <Icon name="trash" />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </Table>
                                            ) : (
                                                <div className="alert alert-info text-center">
                                                    No hay participantes agregados.
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div className="mt-4 pt-3 border-top">
                                        <h6 className="font-weight-bold">Condiciones del descuento</h6>
                                        <div className="row mb-3 mt-3">
                                            <div className="col-md-6">
                                                <Input
                                                    color=""
                                                    className="material"
                                                    labelClass="material"
                                                    label="Cantidad mínima SKU distintos"
                                                    placeholder="Ej: 5"
                                                    type="number"
                                                    value={this.state.surtido_volumen_min_sku}
                                                    onChange={(e) => this.setState({ surtido_volumen_min_sku: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <Input
                                                    color=""
                                                    className="material"
                                                    labelClass="material"
                                                    label="Cantidad mínima total en bultos / cajas / cestas"
                                                    placeholder="Ej: 100"
                                                    type="number"
                                                    value={this.state.surtido_volumen_min_bultos}
                                                    onChange={(e) => this.setState({ surtido_volumen_min_bultos: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        <h6 className="font-weight-bold mt-4">Porcentajes a aplicar</h6>
                                        <div className="row mb-3 mt-3">
                                            <div className="col-md-6">
                                                <Input
                                                    color=""
                                                    className="material"
                                                    labelClass="material"
                                                    label="% Descuento si cumple solo una"
                                                    placeholder="Ej: 5"
                                                    type="number"
                                                    value={this.state.surtido_volumen_percentage_one}
                                                    onChange={(e) => this.setState({ surtido_volumen_percentage_one: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <Input
                                                    color=""
                                                    className="material"
                                                    labelClass="material"
                                                    label="% Descuento si cumple ambas"
                                                    placeholder="Ej: 10"
                                                    type="number"
                                                    value={this.state.surtido_volumen_percentage_both}
                                                    onChange={(e) => this.setState({ surtido_volumen_percentage_both: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="alert alert-warning">
                                    La configuración para el tipo "{discountTypes.find(t => t.value === type)?.label}" aún no está implementada en esta versión.
                                </div>
                            )}
                        </div>
                    )}

                    <div className="d-flex justify-content-center mt-4 mb-2">
                        {step === 1 ? (
                            <Button color=" " className="primary" type="button" onClick={this.handleNext} style={{ width: '150px' }}>
                                Siguiente
                            </Button>
                        ) : (
                            <Button
                                color=" "
                                className="primary"
                                type="button"
                                onClick={(isGeneral || isSurtido || isVolumen || isProntoPago || isRutaVendedor || isLimiteCantidad || isSurtidoVolumen) ? this.handleSave : null}
                                disabled={!(isGeneral || isSurtido || isVolumen || isProntoPago || isRutaVendedor || isLimiteCantidad || isSurtidoVolumen)}
                                style={{ width: '150px' }}
                            >
                                Guardar
                            </Button>
                        )}
                    </div>
                </BModal.Body>
            </BModal >
        );
    }
}

export default ModalDiscount;
